<div class="full-screen-container bg-nuevo-registro">
  <div class="d-flex justify-content-center pt-5">
    <img src="assets/img/logo-tyver.svg" alt="logo tyver" class="logo-wizard">
  </div>
  <router-outlet></router-outlet>
</div>
